import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Avatar,
  IconButton,
  InputAdornment,
  Grid,
  Link
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import ReCAPTCHA from "react-google-recaptcha";

const Login = () => {
  let xURL = "";
  let xlocation = window.location.hostname;
  let secretKey = "";

  if (xlocation === "localhost") {
    xURL = "http://localhost:3001/api/";
    secretKey = "6Lcx3xcqAAAAAJq16RqUkH3Tf60h3G6n-rq9GTDx";
  } else {
    xURL = "https://sau.rihes.cmu.ac.th/api/";
    secretKey = "6LcQMG8rAAAAAFRKvJ0BSEE34tfRDkz_9BVOP6hj";
  }

  const recaptchaRef = useRef();

  const [ReCAPTCHAValue, _ReCAPTCHAValue] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  useEffect(() => {
    //localStorage.removeItem("token");
    //console.log(localStorage.token);
    _ReCAPTCHAValue("");

    if (localStorage.token) {
      window.location = "/";
    }
  }, []);

  const handleSubmit = event => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    // console.log({
    //   username: data.get("username"),
    //   password: data.get("password")
    // });

    if (!data.get("username")) {
      Swal.fire({
        title: "Signin failed",
        text: "Username is invalid",
        icon: "info"
      });
    } else if (!data.get("password")) {
      Swal.fire({
        title: "Signin failed",
        text: "Password is invalid",
        icon: "info"
      });
    } else if (ReCAPTCHAValue == "" || ReCAPTCHAValue == null) {
      Swal.fire({
        title: "Signin failed",
        text: "ReCAPCHA not verified yet",
        icon: "info"
      });
    } else {
      axios
        .post(xURL + "verify-captcha", {
          token: ReCAPTCHAValue
        })
        .then(result => {})
        .catch(function(error) {
          // handle error
          console.log("problem here", error);
        });

      axios
        .post(xURL + "login", {
          username: data.get("username"),
          password: data.get("password")
        })
        .then(result => {
          if (result.data.status === "ok") {
            //alert("login sucess");
            Swal.fire({
              title: "Signin successful",
              text: "please wait a moment ...",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              customClass: {
                container: "my-swal"
              }
            }).then(() => {
              localStorage.setItem("token", result.data.token);

              window.location = "/manage";
            });
          } else {
            Swal.fire({
              title: "Signin error",
              text: "Username or Password invalid",
              icon: "error",
              showConfirmButton: false,
              timer: 2000,
              customClass: {
                container: "my-swal"
              }
            });
          }
        })
        .catch(function(error) {
          // handle error
          console.log("problem here", error);
        });
    }
  };

  function onChangeRecap(value) {
    // console.log("Captcha value:", value);
    _ReCAPTCHAValue(value);
  }

  return (
    <React.Fragment>
      <Box
        sx={{
          height: "100vh",
          background:
            "linear-gradient(to right,rgb(16, 209, 235),rgb(0, 93, 253))",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Paper
          elevation={6}
          sx={{
            p: 4,
            maxWidth: 400,
            width: "100%",
            borderRadius: 3,
            textAlign: "center"
          }}
        >
          <Avatar sx={{ m: "auto", bgcolor: "primary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography variant="h5" mt={2} mb={3}>
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type={showPassword ? "text" : "password"}
              id="password"
              autoComplete="current-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleClickShowPassword} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "center"
              }}
            >
              <ReCAPTCHA
                sitekey={secretKey}
                onChange={onChangeRecap}
                ref={recaptchaRef}
              />
            </Box>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
          </Box>
        </Paper>
      </Box>
    </React.Fragment>
  );
};

export default Login;
